import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/47.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Odrzucasz ofertę"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p88,
            }}
            content={
                <div>
                    <ul>
                        <li>Dziękuję, ale to chyba nie dla mnie! – mówisz z uśmiechem do starego Tornaua.</li>
                        <li>Zawsze możesz zmienić zdanie! Będzie czekało na ciebie miejsce – odpowiada życzliwie.</li>
                    </ul>
                    <p>
                        Po wieczorze spędzonym u Jasińskiej postanawiasz, że czas ruszać dalej. Żegnasz się ze wszystkimi serdecznie i zaczynasz iść przed siebie. Z każdym twoim krokiem spod wieczornego nieba zaczynają się wyłaniać drzewa. No nareszcie, las! Patrzysz ostatni raz na Zagórów: miasteczko olędrów, Polaków i Żydów, gęsiarzy, rzemieślników i rybaków. Miasteczko oczek wodnych, łąk nadwarciańskich i wilgotnych lasów. A przede wszystkim twoich przyjaciół. Wiesz, że zapamiętasz tę wyprawę na długo. I mówisz w myślach: „Do zobaczenia!”.
                    </p>
                </div>
            }
        />

    );
}